import { useIntl } from 'react-intl'

function useExperienceSearchLabels() {
  const intl = useIntl()

  return {
    locationLabel: intl.formatMessage({
      id: 'WegtSzfCH5',
      defaultMessage: 'Where',
      description: 'Label for experience search location input in the search interface',
    }),
    locationPlaceholder: intl.formatMessage({
      id: 'Ewg3EeQvVW',
      defaultMessage: 'Search by destination or experience',
      description: 'Placeholder text for experience search location input',
    }),
    searchButton: intl.formatMessage({
      id: 'mgeoBdt41H',
      defaultMessage: 'Search',
      description: 'Button text to submit experience search form in the search interface',
    }),
  }
}

export default useExperienceSearchLabels
